export const parseMultilineEntries = (value: string): string[] =>
  value
    .split('\n')
    .map(entry => entry.trim())
    .filter(entry => entry.length > 0)

export const hasRequiredPrefix = (value: string, prefix: string): boolean =>
  value.startsWith(prefix)

export const findEntriesWithPrefix = (entries: string[], prefix: string): string[] =>
  entries.filter(entry => hasRequiredPrefix(entry, prefix))

export const findEntriesWithoutPrefix = (entries: string[], prefix: string): string[] =>
  entries.filter(entry => !hasRequiredPrefix(entry, prefix))
